<template>
  <main class="device_detail_wrap">
    <div
      data-v-05ab5af4=""
      class="modal_wrap bottom_modal"
      autoestimation=""
      :class="{ on: isOpen }"
      v-if="deviceDetail"
    >
      <div class="modal_inner" @click.self="$emit('close')">
        <div class="modal">
          <div class="device_detail_pop">
            <div class="device_detail_wrap">
              <div class="device_info_1">
                <div class="d_img">
                  <img :src="selectColorImage" alt="" />
                </div>
                <div class="d_info">
                  <div class="d_txt_1">{{ deviceDetail.modelName }}</div>
                  <div class="d_txt_2">{{ deviceDetail.deviceName }}</div>
                  <div class="d_txt_4">
                    <span>공시지원</span>
                    {{ toCurrency(deviceDetail.supportMoney) }}원
                  </div>
                  <div class="d_txt_4">
                    <span>출고가</span>
                    {{ toCurrency(deviceDetail.factoryPrice) }}원
                  </div>
                </div>
              </div>
              <div class="device_info_2">
                <div class="device_spec_1">
                  <div
                    class="device_spec"
                    v-for="(items, index1) in deviceSpec1"
                    :key="index1"
                  >
                    <div
                      class="spec_list"
                      v-for="(item, index2) in items"
                      :key="index2"
                    >
                      <div class="spec_img">
                        <img
                          :src="
                            require(`@/assets/front/images/mobile/${item.img}`)
                          "
                          alt=""
                        />
                      </div>
                      <div class="spec_title">{{ item.name }}</div>
                      <div v-if="index1 == 0 && index2 == 0" class="spec_txt">
                        {{ deviceDetail.os }}
                      </div>
                      <div
                        v-else-if="index1 == 0 && index2 == 1"
                        class="spec_txt"
                      >
                        {{ deviceDetail.ram }}
                      </div>
                      <div
                        v-else-if="index1 == 0 && index2 == 2"
                        class="spec_txt"
                      >
                        {{ deviceDetail.battery }}
                      </div>
                      <div
                        v-else-if="index1 == 1 && index2 == 0"
                        class="spec_txt"
                      >
                        {{ deviceDetail.size }}
                      </div>
                      <div
                        v-else-if="index1 == 1 && index2 == 1"
                        class="spec_txt"
                      >
                        {{ deviceDetail.memoryEmb }}
                      </div>
                      <div
                        v-else-if="index1 == 1 && index2 == 2"
                        class="spec_txt"
                      >
                        {{ deviceDetail.memoryExt }}
                      </div>
                      <div
                        v-else-if="index1 == 2 && index2 == 0"
                        class="spec_txt"
                      >
                        {{ deviceDetail.display }}
                      </div>
                      <div
                        v-else-if="index1 == 2 && index2 == 1"
                        class="spec_txt"
                      >
                        {{ deviceDetail.cpu }}
                      </div>
                      <div
                        v-else-if="index1 == 2 && index2 == 2"
                        class="spec_txt"
                      >
                        {{ deviceDetail.camera }}
                      </div>
                    </div>
                  </div>
                </div>
                <div class="device_spec_2">
                  <div
                    class="device_spec"
                    v-for="(item, index) in deviceSpec2"
                    :key="index"
                  >
                    <div class="device_txt_1">{{ item.title }}</div>
                    <div
                      v-if="index == 0"
                      class="device_txt_2"
                      v-html="
                        $options.filters.nl2br(
                          decodeBase64(deviceDetail.specialExplain),
                        )
                      "
                    ></div>
                    <div
                      v-else-if="index == 1"
                      class="device_txt_2"
                      v-html="
                        $options.filters.nl2br(
                          decodeBase64(deviceDetail.designExplain),
                        )
                      "
                    ></div>
                    <div
                      v-else-if="index == 2"
                      class="device_txt_2"
                      v-html="
                        $options.filters.nl2br(
                          decodeBase64(deviceDetail.cameraExplain),
                        )
                      "
                    ></div>
                    <div
                      v-else-if="index == 3"
                      class="device_txt_2"
                      v-html="
                        $options.filters.nl2br(
                          decodeBase64(deviceDetail.componentExplain),
                        )
                      "
                    ></div>
                  </div>
                </div>
              </div>
              <div class="device_info_3">
                <div class="info_title">선택한 모델의 색상을 선택해주세요!</div>
                <div class="info_txt">
                  <div class="txt_1">- {{ selectColorName }}</div>
                  <div class="txt_2 checkbox">
                    <label>
                      <input type="checkbox" v-model="noColor" />
                      <span>
                        색상상관없음
                      </span>
                    </label>
                  </div>
                </div>
                <div class="info_color">
                  <ul>
                    <li
                      v-for="(item, index) in deviceDetail.colors"
                      :key="index"
                    >
                      <div
                        class="color_list"
                        :class="{ on: selectColorIndex == index }"
                        @click="
                          selectColor(
                            item.colorCode,
                            item.colorName,
                            item.colorImage,
                            index,
                          )
                        "
                      >
                        <div
                          class="color_sel"
                          :style="`background-color:#${item.colorCode}`"
                        ></div>
                        <div class="color_check">
                          <img
                            :src="
                              require(`@/assets/front/images/mobile/ic_color_check.svg`)
                            "
                            alt=""
                          />
                        </div>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div class="btm_btn">
              <div class="btn_wrap">
                <button class="btn bo" @click.stop.prevent="close">
                  돌아가기
                </button>
                <button class="btn" @click.stop.prevent="select">
                  모델 선택하기
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import * as util from '@common/lib/common/utils.js';
export default {
  name: 'deviceDetailModal',
  props: {
    deviceDetail: Object,
  },
  components: {},
  async created() {
    // console.log(this.deviceDetail);
    // console.log('this.deviceDetail');
    // console.log(this.deviceDetail2);
    // this.selectColorCode = this.deviceDetail.colors[0].colorCode;
    // this.selectColorName = this.deviceDetail.colors[0].colorName;
    // this.selectColorCode = '';
    // this.selectColorName = '';
  },
  data() {
    return {
      // deviceDetail: [],
      isOpen: false,
      noColor: false,
      // deviceDetail: {},
      selectColorIndex: 0,
      selectColorCode: '',
      selectColorName: '',
      selectColorImage: '',
      deviceSpec2: [
        {
          title: 'Special',
        },
        {
          title: 'Design',
        },
        {
          title: 'Camera',
        },
        {
          title: '구성품',
        },
      ],
      deviceSpec1: [
        [
          {
            img: 'ic_option_01.svg',
            name: 'OS',
          },
          {
            img: 'ic_option_02.svg',
            name: 'RAM',
          },
          {
            img: 'ic_option_03.svg',
            name: '배터리',
          },
        ],
        [
          {
            img: 'ic_option_04.svg',
            name: '화면크기',
          },
          {
            img: 'ic_option_05.svg',
            name: '내장메모리',
          },
          {
            img: 'ic_option_06.svg',
            name: '외장메모리',
          },
        ],
        [
          {
            img: 'ic_option_07.svg',
            name: '디스플레이',
          },
          {
            img: 'ic_option_08.svg',
            name: 'CPU',
          },
          {
            img: 'ic_option_09.svg',
            name: '카메라',
          },
        ],
      ],
    };
  },
  filters: {
    comma(val) {
      return String(val).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    },
    nl2br(val) {
      return String(val)
        .split('\n')
        .join('<br />');
    },
  },
  computed: {
    // deviceDetailInfo() {
    //   return this.deviceDetail;
    // },
  },
  methods: {
    toCurrency(val) {
      return util.toCurrency(val);
    },
    decodeBase64(val) {
      return util.decodeBase64(val);
    },
    close() {
      this.$emit('close');
    },
    select() {
      this.$emit(
        'select',
        this.selectColorName,
        this.noColor,
        this.deviceDetail.deviceImage,
        this.deviceDetail.factoryPrice,
      );
    },
    selectColor(code, name, image, index) {
      this.selectColorCode = code;
      this.selectColorName = name;
      this.selectColorImage = image;
      this.selectColorIndex = index;
    },
  },
};
</script>
